fx.ns("shared.extractors", class HeicExtractor extends shared.MediaExtractor {

    constructor(parameters)
    {
        super(parameters);

    }

    _processQueue()
    {
        if (this._queueFiles.length > 0)
        {
            this.currentFile = this._queueFiles.shift();

            this.currentFile.image = new Image();
            this.currentFile.image.setAttribute("crossorigin","anonymous"); // added in order to avoid => "Failed to execute 'toDataURL' on 'HTMLCanvasElement': Tainted canvases may not be exported."
            
            this.currentFile.image.src = this.currentFile.thumb;

            //this.currentFile.image.onload = this.onLoaded.bind(this, srcUrl);
            this.on("load", this._onPhotoLoaded, this.currentFile.image);
        }
    }

    /*onLoaded(srcUrl)
    {
        this._createPhoto(srcUrl);
    }*/

    _onPhotoLoaded()
    {
        this.off("load", this._onPhotoLoaded, this.currentFile.image);

        let newWidth1 = this.thumbSize;
        let newHeight1 = newWidth1 * this.currentFile.image.height / this.currentFile.image.width;
        let dataImg = fx.graphics.imageToDataUri(this.currentFile.image, newWidth1, newHeight1); 

        this.currentFile.prop("base64", dataImg);
       
        this.trigger("photo-extracted", this.currentFile);

        this._processQueue();
    }
   
});